export default "__VITE_ASSET__CdL2oUyj__"